import { GET_FAQ } from "../actions/types";

const initialState = {
  faq: {},
  loading: false
};
const faqReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_FAQ:
      return {
        ...state,
        faq: payload,
        loading: false
      };
    
    default:
      return state;
  }
};

export default faqReducer;
